import AllRoutes from "./allroutes/AllRoutes";
import { Provider } from "react-redux";
import store from "./redux/store";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import AppInitializer from "./components/AppInitializer";

function App() {

  return (
    <div className="App">
      <Provider store={store}>
        <ToastContainer style={{ marginTop: "120px" }} />

        <AppInitializer>
          <AllRoutes />
        </AppInitializer>
      </Provider>
    </div>
  );
}

export default App;
